export const FORMAT_DATE_TIME_SHORT = "dd.MM.yyyy HH:mm:ss";
export const FORMAT_DATE_TIME_SHORTER = "dd.MM.yyyy HH:mm";
export const FORMAT_DATE_TIME_SHORTEST = "dd.MM. HH:mm";
export const FORMAT_DATE = "dd.MM.yyyy";
export const FORMAT_TIME = "HH:mm";
export const FORMAT_DAY_OF_WEEK_NUMERIC = "i";

export const FORMAT_DATE_MOMENT = "DD.MM.YYYY";
